import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { PlatformLocation } from '@angular/common';
import Swal from 'sweetalert2'
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProcessosService {

  processosGet$ = new BehaviorSubject(null);
  processosPost$ = new BehaviorSubject(null);
  processosPut$ = new BehaviorSubject(null);
  processosDelete$ = new BehaviorSubject(null);

  constructor(private http: HttpClient, private platformLocation: PlatformLocation) { }

  //Buscar Processos
  get(id_cliente) {
    try {
      var url: string = environment.advFirmasWebApi + '/api/' + environment.versao + "/CadastroPoderes/lista_de_poder_cliente_autorizador/" + id_cliente + "/" + environment.empresa;

      this.http.get(url).subscribe({
        next: (data) => this.processosGet$.next(data),
        error: (error: HttpErrorResponse) => {
          this.processosGet$.next(false);
          if (error.status === 500) {
            Swal.fire({
              'width': 500,
              'title': 'Oops...',
              'text': error.error.detail,
              'icon': 'error'
            });
          } else {
            Swal.fire('Oops...', 'Algo deu errado, por favor entre em contato com o Suporte!', 'error');
          }
        }
      }).add(() => {
        this.processosGet$.unsubscribe(),
        this.processosGet$ = new BehaviorSubject(null);
      });
    } catch (e) {
      Swal.fire({
        title: "Oops...",
        text: "Algo deu errado, por favor entre em contato com o Suporte!",
        icon: "error",
        timer: 1500,
        showCancelButton: false,
        showConfirmButton: true
      });
    }
  }

  //Incluir Faixa
  post(faixa: any) {
    try {
      var headers = new HttpHeaders();
      headers.append('Content-Type', 'application/json');
      faixa.empresa = environment.empresa;

      var url: string = environment.advFirmasWebApi + '/api/' + environment.versao + "/CadastroPoderes/IncluirFaixa"

      this.http.post(url, faixa, { headers: headers }).subscribe({
        next: (data) => this.processosPost$.next(data),
        error: (error: HttpErrorResponse) => {
          this.processosPost$.next(false);
          if (error.status === 500) {
            Swal.fire({
              'width': 500,
              'title': 'Oops...',
              'text': error.error.detail,
              'icon': 'error'
            });
          } else {
            Swal.fire('Oops...', 'Algo deu errado, por favor entre em contato com o Suporte!', 'error');
          }
        }
      }).add(() => {
        this.processosPost$.unsubscribe(),
        this.processosPost$ = new BehaviorSubject(null);
      });
    } catch (e) {
      Swal.fire({
        title: "Oops...",
        text: "Algo deu errado, por favor entre em contato com o Suporte!",
        icon: "error",
        timer: 1500,
        showCancelButton: false,
        showConfirmButton: true
      });
    }
  }

  //Editar Faixa
  put(faixa: any) {
    try {
      var headers = new HttpHeaders();
      headers.append('Content-Type', 'application/json');
      faixa.empresa = environment.empresa;

      var url: string = environment.advFirmasWebApi + '/api/' + environment.versao + "/CadastroPoderes/EditarFaixa"

      this.http.put(url, faixa, { headers: headers }).subscribe({
        next: (data) => this.processosPut$.next(data),
        error: (error: HttpErrorResponse) => {
          this.processosPut$.next(false);
          if (error.status === 500) {
            Swal.fire({
              'width': 500,
              'title': 'Oops...',
              'text': error.error.detail,
              'icon': 'error'
            });
          } else {
            Swal.fire('Oops...', 'Algo deu errado, por favor entre em contato com o Suporte!', 'error');
          }
        }
      }).add(() => {
        this.processosPut$.unsubscribe(),
        this.processosPut$ = new BehaviorSubject(null);
      });
    } catch (e) {
      Swal.fire({
        title: "Oops...",
        text: "Algo deu errado, por favor entre em contato com o Suporte!",
        icon: "error",
        timer: 1500,
        showCancelButton: false,
        showConfirmButton: true
      });
    }
  }

  //Deletar Faixa
  del(faixa: any) {
    try {
      const options = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
        body: faixa
      };

      var url: string = environment.advFirmasWebApi + '/api/' + environment.versao + "/CadastroPoderes/ExcluirFaixa";
      faixa.empresa = environment.empresa;

      this.http.delete(url, options).subscribe({
          next: (res: any) => this.processosDelete$.next(res),
          error: (error: HttpErrorResponse) => {
            this.processosDelete$.next(false);
            if (error.status === 500) {
              Swal.fire({
                'width': 500,
                'title': 'Oops...',
                'text': error.error.detail,
                'icon': 'error'
              });
            } else {
              Swal.fire('Oops...', 'Algo deu errado, por favor entre em contato com o Suporte!', 'error');
            }
          }  
        }).add(() => {
          this.processosDelete$.unsubscribe(),
          this.processosDelete$ = new BehaviorSubject(null);
        });
    } catch (e) {
      Swal.fire({
        title: "Oops...",
        text: "Algo deu errado, por favor entre em contato com o Suporte!",
        icon: "error",
        timer: 1500,
        showCancelButton: false,
        showConfirmButton: true
      });
    }
  }
}
